import ResumeArea from './ResumeArea';

export default ResumeArea;
